import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const createRoom = (payload) => api.post(`/rooms/create`, payload).then((r) => r.data);
export const joinRoom = (code, payload) => api.post(`/rooms/${code}/join`, payload).then((r) => r.data);
export const getRoom = (code, playerId) =>
  api.get(`/rooms/${code}`, { params: playerId ? { player_id: playerId } : {} }).then((r) => r.data);
export const listRooms = () => api.get(`/rooms`).then((r) => r.data);
export const deleteRoom = (code, playerId) =>
  api.delete(`/rooms/${code}`, { params: { player_id: playerId } }).then((r) => r.data);
export const setRole = (code, payload) => api.post(`/rooms/${code}/role`, payload).then((r) => r.data);
export const startGame = (code, playerId) =>
  api.post(`/rooms/${code}/start`, { player_id: playerId }).then((r) => r.data);
export const resetGame = (code, playerId) =>
  api.post(`/rooms/${code}/reset`, { player_id: playerId }).then((r) => r.data);
export const sendClue = (code, payload) => api.post(`/rooms/${code}/clue`, payload).then((r) => r.data);
export const revealCard = (code, payload) => api.post(`/rooms/${code}/reveal`, payload).then((r) => r.data);
export const endTurn = (code, playerId) =>
  api.post(`/rooms/${code}/end-turn`, { player_id: playerId }).then((r) => r.data);
